var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderDetailed)?_c('div',{staticClass:"pt-5"},[_c('details-module',{attrs:{"order-detailed":_vm.orderDetailed,"title":_vm.orderDetailed.siteName,"is-no-show":true,"is-cancelled":true,"return-to-profile-button":true,"can-see-receipt":true,"layout":"portal"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }